"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_DATE_SELECTION = exports.LFC_STATE_KEY = exports.LFC_ROLE = exports.LFC_MEMBER = exports.DATA_FORMAT_STATE_KEY = exports.CALENDAR_VIEW_TYPE = exports.CALENDAR_TYPE = exports.CALENDAR_TRIP_TYPE = exports.CALENDAR_SELECTION_TYPE = void 0;
var CALENDAR_TYPE = {
  CHECKIN: 'checkin',
  CHECKOUT: 'checkout'
};
exports.CALENDAR_TYPE = CALENDAR_TYPE;
var CALENDAR_VIEW_TYPE = {
  DESKTOP: 1,
  MOBILE: 2
};
exports.CALENDAR_VIEW_TYPE = CALENDAR_VIEW_TYPE;
var CALENDAR_SELECTION_TYPE = {
  ONE: 1,
  TWO: 2
};
exports.CALENDAR_SELECTION_TYPE = CALENDAR_SELECTION_TYPE;
var CALENDAR_TRIP_TYPE = {
  ONEWAY: 'O',
  RETURN: 'R'
};
exports.CALENDAR_TRIP_TYPE = CALENDAR_TRIP_TYPE;
var TOGGLE_DATE_SELECTION = {
  DEPART: 1,
  RETURN: 2
};
exports.TOGGLE_DATE_SELECTION = TOGGLE_DATE_SELECTION;
var LFC_STATE_KEY = {
  ONEWAY: 'snap_lfc_prize_oneway',
  RETURN: 'snap_lfc_price_return'
};
exports.LFC_STATE_KEY = LFC_STATE_KEY;
var DATA_FORMAT_STATE_KEY = {
  DATE: 'hotel_data_format_date',
  CURRENCY: 'hotel_data_format_currency'
};
exports.DATA_FORMAT_STATE_KEY = DATA_FORMAT_STATE_KEY;
var LFC_MEMBER = {
  ANONYMOUS: 0,
  LOGGEDIN: 1
};
exports.LFC_MEMBER = LFC_MEMBER;
var LFC_ROLE = {
  DESKTOP: 0,
  MOBILE: 1
};
exports.LFC_ROLE = LFC_ROLE;